// DS: i3.3
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Edit: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        d="M11.596 1.632l2.585 2.585a1 1 0 010 1.415l-8.415 8.415a1 1 0 01-.737.293l-2.512-.074a1 1 0 01-.97-.97l-.074-2.512a1 1 0 01.293-.737l8.415-8.415a1 1 0 011.415 0zM8.613 6.027l-5.128 5.129.033 1.138 1.138.034 5.129-5.13-1.172-1.171zm1.414-1.414l.861-.86 1.172 1.171-.861.86-1.172-1.171z"
        clipRule="evenodd"
      ></path>
    </svg>
  </IconWrap>
);
Edit.displayName = 'Edit';

export default Edit;
